<template>
  <div class="row">
    <div class="col-md-6 col-sm-12">
      <div class="doc">
        <p class="key-doc">{</p>
        <div class="documento" v-html="createHtml(before)"></div>
        <p class="key-doc">}</p>
      </div>
    </div>
    <div class="col-md-6 col-sm-12">
      <div class="doc">
        <p class="key-doc">{</p>
        <div class="documento" v-html="createHtml(after)"></div>
        <p class="key-doc">}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { htmlScape } from '../utils/stringUtils'
export default {
  props: {
    jsonbefore: {
      type: [Array, Object],
      default: () => ({}),
      required: false,
    },
    jsonafter: {
      type: [Array, Object],
      default: () => ({}),
      required: false,
    },
  },
  data: function() {
    return {
      before: null,
      after: null,
      htmlBefore: '',
      htmlAfter: '',
    }
  },
  mounted() {
    if (this.jsonbefore) {
      const jsonbefore =
        Array.isArray(this.jsonbefore) && this.jsonbefore.length == 1
          ? this.jsonbefore[0]
          : this.jsonbefore
      this.before = this.mapAny(jsonbefore)
    }
    if (this.jsonafter) {
      const jsonafter =
        Array.isArray(this.jsonafter) && this.jsonafter.length == 1
          ? this.jsonafter[0]
          : this.jsonafter
      this.after = this.mapAny(jsonafter)
    }
    this.mapDiff(this.before, this.after, 'removed')
    this.mapDiff(this.after, this.before, 'add')
  },
  methods: {
    createHtml(objectMapped) {
      let html = ''
      const _this = this
      if (objectMapped == null || objectMapped == '') {
        return ''
      } else if (Array.isArray(objectMapped)) {
        objectMapped.forEach(function(element) {
          html += _this.createHtml(element)
        })
      } else {
        const openKey =
          objectMapped.type == 'Array'
            ? '<span class="keypair">[</span>'
            : objectMapped.type == 'Object'
            ? '<span class="keypair">{</span>'
            : ''
        const closeKey =
          objectMapped.type == 'Array'
            ? '<span class="keypair">]</span>'
            : objectMapped.type == 'Object'
            ? '<span class="keypair">}</span>'
            : ''

        html += `<div class="doc-item ${
          objectMapped.type
        } ${objectMapped.diff ||
          ''}" style="padding-left:${objectMapped.spaces * 5}px">
        <span class="key">"${objectMapped.key}" : </span>${openKey}`

        if (!Array.isArray(objectMapped.value)) {
          html += `<span class="value">${
            objectMapped.type == 'String' ? '"' : ''
          }${
            objectMapped.type == 'String'
              ? htmlScape(objectMapped.value)
              : objectMapped.value
          }${objectMapped.type == 'String' ? '"' : ''}</span>`
        } else {
          html += this.createHtml(objectMapped.value)
        }
        html += `${closeKey}</div>`
      }
      return html
    },
    mapAny(any, spaces = 0) {
      if (this.isSimpleType(any)) {
        return [{ spaces, key: 'index', type: this.type(any), value: any }]
      } else if (this.isObject(any, spaces)) {
        return this.mapObject(any, spaces)
      } else if (this.isArray(any, spaces)) {
        return this.mapArray(any, spaces)
      } else {
        return [{ spaces, key: 'index', type: 'unknow', value: 'unknow' }]
      }
    },
    mapObject(object, spaces = 0) {
      const _this = this
      return Object.keys(object).map(function(key) {
        const objItem = object[key]
        if (_this.isSimpleType(objItem)) {
          return { spaces, key, type: _this.type(objItem), value: objItem }
        } else {
          if (_this.isObject(objItem)) {
            return {
              spaces,
              key,
              type: _this.type(objItem),
              value: _this.mapObject(objItem, spaces + 1),
            }
          } else if (_this.isArray(objItem)) {
            return {
              spaces,
              key,
              type: _this.type(objItem),
              value: _this.mapArray(objItem, spaces + 1),
            }
          } else {
            return { spaces, key, type: 'unknow', value: 'unknow' }
          }
        }
      })
    },
    mapArray(value, spaces = 0) {
      const _this = this
      return value.map(function(item, index) {
        if (_this.isSimpleType(item)) {
          return { spaces, key: index, type: _this.type(item), value: item }
        } else {
          if (_this.isObject(item)) {
            return {
              spaces,
              key: index,
              type: _this.type(item),
              value: _this.mapObject(item, spaces + 1),
            }
          } else if (_this.isArray(item)) {
            return {
              spaces,
              key: index,
              type: _this.type(item),
              value: _this.mapArray(item, spaces + 1),
            }
          } else {
            return { spaces, key: index, type: 'unknow', value: 'unknow' }
          }
        }
      })
    },
    mapDiff(obj1, obj2, dontFound) {
      if (obj1 != obj2 && obj1 != null) {
        const _this = this
        obj1.map(function(item) {
          const itemObj2 = _this.findItemKey(item.key, obj2)
          switch (item.type) {
            case 'Object':
            case 'Array':
              if (!itemObj2 || itemObj2.key != item.key) {
                item.diff = dontFound
              }
              _this.mapDiff(item.value, itemObj2.value, dontFound)
              break
            case 'Number':
            case 'String':
            case 'Boolean':
            case 'Undefined':
            case 'Null':
              if (itemObj2 && itemObj2.key == item.key) {
                if (item.value !== itemObj2.value) {
                  item.diff = 'change'
                }
              } else {
                item.diff = dontFound
              }
              break
            default:
              break
          }
        })
      }
    },
    findItemKey(key, item) {
      if (Array.isArray(item)) {
        const itemFind = item.filter(function(value) {
          return value && value.key === key
        })
        return itemFind[0] || { key: null, value: null }
      } else {
        return { key: null, value: null }
      }
    },
    isArray(item) {
      return Object.prototype.toString.call(item) === '[object Array]'
    },
    isObject(item) {
      return Object.prototype.toString.call(item) === '[object Object]'
    },
    isNull(item) {
      return Object.prototype.toString.call(item) === '[object Null]'
    },
    isNumber(item) {
      return typeof item === 'number'
    },
    isString(item) {
      return typeof item === 'string'
    },
    isBoolean(item) {
      return typeof item === 'boolean'
    },
    isUndefined(item) {
      return typeof item === 'undefined'
    },
    isSimpleType(item) {
      return (
        this.isString(item) ||
        this.isNumber(item) ||
        this.isUndefined(item) ||
        this.isNull(item) ||
        this.isBoolean(item)
      )
    },
    type(item) {
      let type = Object.prototype.toString.call(item)
      const match = /(?!\[).+(?=\])/g
      type = type.match(match)[0].split(' ')[1]
      return type
    },
  },
}
</script>
<style>
.doc {
  background-color: #514f4f;
  padding: 5px;
  border-radius: 5px;
}
.documento {
  padding: 10px;
}
.doc-item {
  width: 100%;
  margin: 2px 0px;
  border-radius: 5px;
  background-color: transparent;
}
.doc-item span {
  margin-left: 10px;
}
.key-doc {
  width: 100%;
}
.doc-item:not(:last-child)::after {
  content: ',';
}
.doc-item .key, .keypair{
  color: #fff;
}
.doc-item.Null .value,
.doc-item.Boolean .value {
  color: #0029fa;
  font-weight: 600;
}
.doc-item.String .value {
  color: #B044F2;
  font-weight: 500;
}
.doc-item.change {
  background-color: rgba(255, 255, 85, 8);
  color: #000;
}
.doc-item.add {
  background-color: rgba(76, 177, 247, 0.8);
  color: #000;

}
.doc-item.removed {
  background-color: #f06a6d;
}
.doc-item.add .key,
.doc-item.add .value,
.doc-item.change .key,
.doc-item.change .value {
  color: #000;
}
.doc-item.add .key,
.doc-item.add .value,
.doc-item.removed .key,
.doc-item.removed .value {
  color: #fff;
}
</style>
